






















import { defineComponent } from "@vue/composition-api";
import { RecentAssets } from "@/components.home/recent-assets";
import { RecentStudies } from "@/components.home/recent-studies";
import { ContextHeader } from "@/components.nav/context-header";
import { Divider, Heading, Container, AbsBox } from "@ui";
import { useTranslate } from "@lang";

export default defineComponent({
	components:{
		RecentAssets,
		RecentStudies,
		ContextHeader,
		Divider,
		Heading,
		Container,
		AbsBox,
	},
	setup(){
		const { translate } = useTranslate();
		return {
			translate
		};
	},
});
